/**
 * Implements a mobile layout
 */
import ChartDisplay from '../ChartDisplay';

import './styles.scss';

const ChartMobile = () => (
  <div className='chart__mobile'>
    <ChartDisplay isMobile={true} selected={{ cols: 1, rows: 1 }} />
  </div>
);

export default ChartMobile;
